import Button from '@discover-ui/button';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext/TrackProvider';
import { openConsentPrompt, useConsent } from '@/lib/consent';

/**
 * "Manage cookies" control for the cookie policy page.
 *
 * Re-fires the consent modal so diners can give or withdraw consent at any time — declining after a prior accept withdraws consent and triggers per-service teardown via the consent registry. GDPR-only: off-GDPR there is no consent decision to manage, so it renders nothing. The caller (the cookie policy template) is responsible for placement — outside the CMS body copy for transparency.
 */
const ManageCookies = () => {
  const { isGdprRegion } = useConsent();

  if (!isGdprRegion) {
    return null;
  }

  return (
    <div className="mx-auto flex max-w-[1200px] flex-col items-center gap-3 px-5 pb-12 pt-4 text-center md:pb-16">
      <p className="text-sm leading-normal text-ds-gray-light-700">
        You can review or change your cookie choices at any time.
      </p>
      <TrackProvider button_name="manage cookies" button_type="selection">
        <Button type="button" kind="normal" scale="md" onClick={() => openConsentPrompt()}>
          Manage cookies
        </Button>
      </TrackProvider>
    </div>
  );
};

export default ManageCookies;
